export default __webpack_public_path__ + "static/project-slide-4-768-700-f3c9b31b316d419f8d3f78ced1551c72.webp";